import { useState } from "react";
import { Gift, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { redeemGift, errorDetail } from "@/lib/reader";

export function GiftNote({ note, onClose }) {
  return (
    <div className="border border-primary-gold/30 bg-primary-gold/5 px-6 py-5 mb-12" data-testid="gift-redeemed-note">
      <p className="font-mono-ui text-[10px] uppercase tracking-[0.25em] text-primary-gold">A gift{note.from_name ? ` from ${note.from_name}` : ""}</p>
      {note.message && <p className="font-serif-display text-xl mt-3 italic" data-testid="gift-redeemed-message">“{note.message}”</p>}
      <button onClick={onClose} className="mt-4 text-xs text-soft hover:text-text-primary" data-testid="gift-redeemed-close">Close</button>
    </div>
  );
}

export default function GiftRedeem({ onRedeemed }) {
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const res = await redeemGift(code.trim());
      toast.success(`Gift redeemed — your pass runs until ${new Date(res.expires_at).toLocaleDateString()}.`);
      setCode("");
      setOpen(false);
      onRedeemed(res);
    } catch (err) {
      toast.error(errorDetail(err));
    } finally {
      setBusy(false);
    }
  };

  if (!open) {
    return (
      <button onClick={() => setOpen(true)} data-testid="gift-redeem-open" className="flex items-center gap-2 font-mono-ui text-xs uppercase tracking-[0.18em] text-soft hover:text-primary-gold transition-colors">
        <Gift className="w-4 h-4" /> Have a gift code?
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3" data-testid="gift-redeem-form">
      <input
        value={code}
        onChange={(e) => setCode(e.target.value)}
        placeholder="GIFT-XXXX-XXXX"
        required
        data-testid="gift-redeem-input"
        className="flex-1 bg-[#0B0C10] border border-white/15 px-4 py-3 font-mono-ui text-sm uppercase tracking-[0.15em] focus:outline-none focus:border-primary-gold"
      />
      <button type="submit" disabled={busy} data-testid="gift-redeem-submit" className="btn-gold px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.18em] flex items-center justify-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />} Redeem
      </button>
    </form>
  );
}
